<template>
<div class="default-vue">
    <div v-if="error">
        Something went wrong
    </div>
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="title && title.length" class="gdlr-item gdlr-item-title-wrapper pos-center">
        <div class="gdlr-item-title-head">
            <h3 class="gdlr-item-title gdlr-skin-border gdlr-skin-title" :class="'gdlr-title-'+titlesize" :style="{'text-align':titleAlign}">{{title}}</h3>
        </div>
    </div>
    <div class="speaker-item-wrapper" :class="{'margin-bottom': marginbottom ? 'margin-bottom': marginbottom =='default'}">
        <div v-if="result && result.vueExperts && result.vueExperts.Experts && !error && !loading">
            <div class="speaker-wrapper d-flex flex-wrap">
                <div v-for="(aSpeaker,speakerIndex) in orderSpeakers(result.vueExperts.Experts)" :key="aSpeaker._id" class="single_speaker_wrapper global-border-radius global-bg-color">  
                    <div class="gdlr-speaker-item single-speaker-box">
                        <a :href="'/speaker/' + aSpeaker.slug" class="gdlr-speaker-thumbnail" :aria-label="aSpeaker.forename + ' ' + aSpeaker.surname">
                            <div class="">
                                <img class="speaker-img" v-if="aSpeaker.avatarSquareSmall && aSpeaker.avatarSquareSmall.xxx && aSpeaker.avatarSquareSmall.xxx !== 'null'" :src="aSpeaker.avatarSquareSmall.xxx" aria-hidden="true" :alt="aSpeaker.forename + ' ' + aSpeaker.surname">
                                <img class="speaker-img" v-else src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/avatarSquareLarge_xx_mustermann_max_ek_1558018462305.png" aria-hidden="true" :alt="aSpeaker.forename + ' ' + aSpeaker.surname">
                            </div>
                        </a>
                        <div class="gdlr-speaker-item-content display-flex-column speaker-info">
                            <h3 class="gdlr-skin-title gdlr-speaker-item-title">
                                <a :href="'/speaker/' + aSpeaker.slug" v-if="aSpeaker.forename && aSpeaker.surname" style="color: black;" :aria-label="aSpeaker.forename + ' ' + aSpeaker.surname" >
                                    <span>{{aSpeaker.forename}}</span> <span>{{aSpeaker.surname}}</span> 
                                </a>
                            </h3>
                            <h4  v-if="aSpeaker.summaryDe" class="speaker-bio h5 language-dependent-block-invisible-de">{{aSpeaker.summaryDe}}</h4>
                            <h4 v-if="aSpeaker.summaryEn" class="speaker-bio h5 language-dependent-block-invisible">{{aSpeaker.summaryEn}}</h4>
                        </div>
                    </div>        
                    <div v-if="(speakerIndex +1) % 4 === 0" class="clear"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="clear"></div>
</div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService'
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
export default {
    name: 'SpeakerListing',
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            Experts: false,
            result: null,
            loading: false,
            error: true,
            extraExpertsForQualification: false,
            brandId: this.settingsPerm.brandid,
            page: this.settingsPerm.page,
            pagesize: this.settingsPerm.pagesize,
            trackFilter: this.settingsPerm.trackFilter,
            speakerQualifications: this.settingsPerm.speakerQualifications,
            thumbnailsize: this.settingsPerm.thumbnailsize,
            speakersize: this.settingsPerm.speakersize,
            speakerstyle: this.settingsPerm.speakerstyle,
            overlaycolor: this.settingsPerm.overlaycolor,
            marginbottom: this.settingsPerm.marginbottom,
            titleAlign: this.settingsPerm.titletype,
            title: null,
            titlesize: this.settingsPerm.titlesize,
            order: this.settingsPerm.order,
            orderby: this.settingsPerm.orderby,
            seriesid: this.settingsPerm.seriesid,
            fetchall: this.settingsPerm.fetchall,
            conferenceUniqueId: false,
            brandsid: this.settingsPerm.brandsid,
            showLanguageFlag: this.settingsPerm.showLanguageFlags,
        }
    },
    mounted() {
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.title && this.settingsPerm.title.length) {
            this.title = this.settingsPerm.title.replace(/_/g, ' ');
        }
        //we need the get conferenceUniqueId from the wp MlC Settings
        this.filterMlcDataToGetConferenceUniqueId();
    },
    updated() {
        setTimeout(() => {
            this.setCookies();
        }, 1200);
    },
    methods: {
        filterMlcDataToGetConferenceUniqueId() {
            if (this.settingsPerm && this.settingsPerm.seriesid && this.settingsPerm.seriesid.length &&
                this.settingsPerm.currentLocationEditionlabel && this.settingsPerm.currentLocationEditionlabel.length && this.settingsPerm.sands_edition_label_data) {
                let editionLabel = this.settingsPerm.currentLocationEditionlabel.toLowerCase();
                if (editionLabel && editionLabel.length) {
                    this.conferenceUniqueId = this.settingsPerm.sands_edition_label_data[editionLabel].edition_identifier;
                    if (this.conferenceUniqueId && this.conferenceUniqueId.length) {
                        this. getExpertsFromBE();
                    }else{
                         this. getExpertsFromBE();
                    }
                }else{
                    this. getExpertsFromBE();
                }
            }else{
                this. getExpertsFromBE();
            }
        },
        setCookies() {
            let theMaybeSetPLLCookieValue = window.jQuery.cookie('pll_language');
            if (theMaybeSetPLLCookieValue && (typeof theMaybeSetPLLCookieValue !== "undefined") && (theMaybeSetPLLCookieValue != "") && (theMaybeSetPLLCookieValue == 'de')) {
                window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
            } else {
                window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
            }
        },
        getExpertsFromBE(){
            if (this.brandsid) {
                this.getExpertsByBrandId();
            } else {
                if (this.speakerQualifications) {
                this.getExpertsFromBEWithQualifications();
                }
                if (this.trackFilter) {
                    this.trackFilter = this.trackFilter.split(",");
                }
                if (this.seriesid) {
                    this.getExpertsById();
                }
            }

        },
        getExpertsFromBEWithQualifications(){
            if (this.speakerQualifications) {
                this.speakerQualifications = this.speakerQualifications.split(",");
                const cache = new InMemoryCache();
                const apolloClient = new ApolloClient({
                    cache,
                    uri: window.walkuere_app_data.concord_url,
                })
                provideApolloClient(apolloClient)
                let variablesForQier = {
                    conferenceSeriesId: this.seriesid,
                    instanceId: this.conferenceUniqueId,
                    pagesize: this.settingsPerm.pagesize + 20,
                    page: 1,
                    qualificationIdIn: [],
                    brandId: this.brandId,
                    trackFilter: [],
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.SPEAKER_QUERY(variablesForQier), variablesForQier);
                watch(result, value => {
                    if (value && value.vueExperts && value.vueExperts.Experts && value.vueExperts.Experts.length) {
                        this.extraExpertsForQualification = value.vueExperts.Experts;
                    }
                })

            }
        },
        getExpertsById(){
            if (this.seriesid) {
                let concordData = queryAndMutaionService.getSpeakers(this.seriesid,this.conferenceUniqueId, parseInt(this.pagesize), parseInt(this.page), this.speakerQualifications, this.brandId, this.trackFilter);
                if (concordData.result) {
                    this.result = concordData.result;
                }
                if (concordData.loading) {
                    this.loading = concordData.loading;
                }
                if (concordData.error) {
                    this.error = concordData.error;
                }
            }
        },
        getExpertsByBrandId(){
            if (this.brandsid) {
                let concordData = queryAndMutaionService.getSpeakersBrandId(parseInt(this.pagesize), parseInt(this.page), this.brandsid);
                if (concordData.result) {
                    this.result = concordData.result;
                }
                if (concordData.loading) {
                    this.loading = concordData.loading;
                }
                if (concordData.error) {
                    this.error = concordData.error;
                }
            }
        },
        orderSpeakers(experts) {
            let didWeReturnExperts = false;
            if (this.speakerQualifications && this.speakerQualifications.length && experts && experts.length && this.extraExpertsForQualification) {
                let extraExpertsForQualification = this.extraExpertsForQualification;
                let filteredExpertsFromQualifications = [];
                let filteredExpertsIdsFromQualifications = [];

                this.speakerQualifications.forEach(aQulification => {
                    let qualificationRelatedExperts = experts.filter(aExpert => {
                        return aExpert.qualifications[0]._id == aQulification;
                    }).sort((a, b) => a.surname.localeCompare(b.surname));
                    if (qualificationRelatedExperts && qualificationRelatedExperts.length) {
                        qualificationRelatedExperts.forEach((aExpert) => {
                            filteredExpertsIdsFromQualifications.push(aExpert._id)
                            filteredExpertsFromQualifications.push(aExpert)
                        })
                    }
                });
                if (filteredExpertsFromQualifications && filteredExpertsFromQualifications.length && extraExpertsForQualification && extraExpertsForQualification.length) {
                    let notMatchingExperts = [];
                    if (extraExpertsForQualification && extraExpertsForQualification.length) {
                        extraExpertsForQualification.forEach(aExpertToFillData => {
                            if (!filteredExpertsIdsFromQualifications.includes(aExpertToFillData._id)) {
                                notMatchingExperts.push(aExpertToFillData);
                            }
                        });
                    }
                    if (notMatchingExperts && notMatchingExperts.length) {
                        notMatchingExperts.sort((a, b) => {
                            return a.surname.localeCompare(b.surname);
                        });
                        let finalExpertsArray = filteredExpertsFromQualifications.concat(notMatchingExperts);
                        return this.getExpertBasedBasedOffetchall(finalExpertsArray);
                    } else {
                        return this.getExpertBasedBasedOffetchall(filteredExpertsFromQualifications);
                    }
                } else {
                    return this.getExpertBasedBasedOffetchall(filteredExpertsFromQualifications);

                }

            } else {
                if (experts && experts.length && experts.length < 35 && this.fetchall == 'disable') {
                    let incomingExpertArr = [...experts];
                    let getEventnumberToSLice;
                    if (incomingExpertArr && incomingExpertArr.length < 35) {
                        getEventnumberToSLice = Math.floor(incomingExpertArr.length / 5) * 4;
                    }
                    if (getEventnumberToSLice && getEventnumberToSLice > 0) {
                        incomingExpertArr = incomingExpertArr.slice(0, getEventnumberToSLice);
                        incomingExpertArr.sort((a, b) => a.surname.localeCompare(b.surname));
                        if (this.order === 'desc') {
                            incomingExpertArr.reverse();
                        }
                        didWeReturnExperts = true;
                        return incomingExpertArr;

                    }
                } else if (experts && experts.length) {
                    let newExpertArr = [...experts]
                    newExpertArr.sort((a, b) => a.surname.localeCompare(b.surname));
                    if (this.order === 'desc') {
                        newExpertArr.reverse();
                    }
                    didWeReturnExperts = true;
                    return newExpertArr;
                }
                if (!didWeReturnExperts) {
                    return experts;
                }
            }

        },
        getExpertBasedBasedOffetchall(experts) {

            if (this.fetchall && this.fetchall == 'disable' && experts && experts.length) {
                if (experts.length >= 32) {
                    return experts.slice(0, 32);
                } else if (experts.length < 32) {
                    let incomingExpertArr = [...experts];
                    let getExpertNumberToSLice;
                    getExpertNumberToSLice = Math.floor(incomingExpertArr.length / 4) * 4;
                    if (getExpertNumberToSLice && getExpertNumberToSLice > 0) {
                        incomingExpertArr = incomingExpertArr.slice(0, getExpertNumberToSLice);
                        return incomingExpertArr;
                    }
                }
            }else{
                return experts;
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.gdlr-speaker-thumbnail img {
    object-fit: cover;
}
.speaker-image{
    height:140px;
    max-height: 140px;
    width:150px;
    object-fit: cover;
}
.speaker-box-height{
    min-height: 260px !important;
    margin-bottom:30px;
}
.single-speaker-box{
    padding: 11px !important;
}
.speaker-img{
    border-radius: 50%;
    width: 150px;
    height: 150px;
}
.display-flex-column{
    display: flex;
    flex-direction: column;

}
.speaker-wrapper{
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    gap: 40px 30px;
}

.single_speaker_wrapper{
    max-width: 15.4%;
    min-width: 262px;

}
.gdlr-speaker-item .gdlr-speaker-item-title{
    font-family: "Open Sans";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.speaker-info{
    word-wrap: break-word;
}
@media only screen and (max-width: 1359.98px){
    .speaker-img{
        width: 120px;
        height: 120px;
    }
    .single_speaker_wrapper{
        max-width: 15.4%;
        min-width: 200px;
    }
}
@media only screen and (max-width: 1023px){
    .speaker-wrapper {
        gap: 32px 32px;
    }
}


@media only screen and (max-width: 767px){
    .speaker-wrapper {
        gap: 26px 26px;
        margin: 0 -10px;
    }
    .gdlr-speaker-item .gdlr-speaker-item-title{
        font-size: 16px;
    }
}
@media only screen and (max-width: 480px){
    .single_speaker_wrapper{
        max-width: calc(50% - 15px);
        min-width: calc(50% - 15px);
    }
    .speaker-wrapper {
        gap: 20px 10px;
    }
        .speaker-img{
        height: 30vw;
        width: 30vw;
    }
}


</style>
